import { ClockIcon, SpeakerWaveIcon } from '@heroicons/react/24/outline';

interface PreviewHeaderProps {
  conversation: {
    name?: string | null;
    duration?: string | null;
    start_timestamp: string;
    is_inbound: boolean;
  };
}

export const PreviewHeader = ({ conversation }: PreviewHeaderProps) => {
  return (
    <div className="px-5 py-3 border-b border-gray-100 bg-gray-50">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-gray-900 truncate">
          {conversation.name || 'Audio Conversation'}
        </h3>
        <span className="flex items-center gap-1 text-xs font-medium px-2 py-1 bg-blue-50 text-blue-700 rounded-full">
          <SpeakerWaveIcon className="h-3 w-3" />
          {conversation.duration}
        </span>
      </div>
      <div className="flex items-center gap-5 mt-1.5 text-xs text-gray-500">
        <div className="flex items-center gap-1">
          <ClockIcon className="h-3.5 w-3.5" />
          <span>{new Date(conversation.start_timestamp).toLocaleString()}</span>
        </div>
        <div>{conversation.is_inbound ? 'Inbound Call' : 'Outbound Call'}</div>
      </div>
    </div>
  );
};
